module.exports = __webpack_public_path__ + "img/appAsset--suppliers-ax.0d494e16.svg";